import React from 'react';
const partners = [{
  name: 'Biltmore',
  logo: 'BILTMORE'
}, {
  name: 'Worcester Art Museum',
  logo: 'Worcester Art Museum'
}, {
  name: 'National Geographic',
  logo: 'NATIONAL GEOGRAPHIC'
}, {
  name: 'Morse Museum',
  logo: 'MORSE MUSEUM'
}, {
  name: 'High Museum',
  logo: 'HIGH'
}, {
  name: 'Denver Art Museum',
  logo: 'Denver Art Museum'
}, {
  name: '9/11 Memorial',
  logo: '9/11 MEMORIAL'
}];
export function PartnerLogos() {
  return <section className="py-20 bg-white" data-id="element-204">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="text-center mb-12" data-id="element-206">
          <p className="text-sm font-semibold text-museum-subtle uppercase tracking-widest" data-id="element-207">
            Trusted by Leading Cultural Institutions
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-8 lg:gap-12 items-center" data-id="element-208">
          {partners.map((partner, i) => <div key={i} className="flex items-center justify-center h-16 px-4 bg-museum-gray rounded-xl" data-id="element-209">
              <span className="text-sm font-bold text-museum-black/60 text-center leading-tight" data-id="element-210">
                {partner.logo}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}